(() => {
  const ready = (fn) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();

  ready(() => {
    if (location.pathname === '/collections/all') {
      const params = new URLSearchParams(location.search);
      if (!params.has('sort_by')) {
        location.replace('/collections/all?sort_by=best-selling');
        return;
      }
      const heading = document.querySelector('main h1');
      if (heading) heading.textContent = 'Canvas Wall Art';
      document.title = 'Canvas Wall Art | TTMCanvas';
    }

    if (!location.pathname.startsWith('/products/')) return;
    const formButton = document.querySelector('button[name="add"], .product-form__submit');
    if (!formButton) return;

    const bar = document.createElement('div');
    bar.className = 'ttm-mobile-buy-bar';
    bar.setAttribute('aria-label', 'Quick purchase');
    bar.innerHTML = '<div class="ttm-mobile-buy-bar__price" aria-live="polite"></div><button class="ttm-mobile-buy-bar__button" type="button">Add to cart</button>';
    const price = bar.querySelector('.ttm-mobile-buy-bar__price');
    const button = bar.querySelector('.ttm-mobile-buy-bar__button');
    document.body.appendChild(bar);

    const update = () => {
      const currentPrice = document.querySelector('.price .price-item--sale, .price .price-item--regular');
      price.textContent = currentPrice ? currentPrice.textContent.trim() : '';
      button.disabled = formButton.disabled;
      button.textContent = formButton.disabled ? 'Unavailable' : 'Add to cart';
    };

    button.addEventListener('click', () => {
      if (!formButton.disabled) formButton.click();
    });

    new MutationObserver(update).observe(formButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-near-form', entry.isIntersecting);
      }, { threshold: .25 }).observe(formButton);
    }

    update();
  });
})();
